module.exports = __webpack_public_path__ + "static/logo-257062cd3ae80ed24fe43379fa00019c.svg";